import React from 'react';

import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import TrackerCard from './trackerCard';

const VideoTelematics = ({ hardwareList, tracker }) => {
  const {
    iotOrderDetailsSection: { labelVideoTelematic }
  } = useLocalizedStringsContext();

  const {
    videoTelematicsTracker,
    additionalServicesTotal,
    addonsTotal,
    vehiclesTotal
  } = tracker;
  const props = {
    title: labelVideoTelematic,
    hardwareList,
    rateplanTotal: videoTelematicsTracker,
    ...(additionalServicesTotal && { additionalServicesTotal }),
    addonsTotal,
    vehiclesTotal
  };
  return <TrackerCard {...props} />;
};

VideoTelematics.propTypes = {
  hardwareList: PropTypes.objectOf(PropTypes.any).isRequired,
  tracker: PropTypes.shape({
    videoTelematicsTracker: PropTypes.number,
    assetTrackerRateplanTotal: PropTypes.number,
    additionalServicesTotal: PropTypes.number,
    addonsTotal: PropTypes.number,
    vehiclesTotal: PropTypes.number
  }).isRequired
};

export default VideoTelematics;
